import { LOCAL_STORAGE_KEYS } from 'src/constants';

/**
 * Reads a persisted drawer width from localStorage with strict validation.
 * Returns defaultWidth if the stored value is missing, non-numeric, or out of range.
 */
export const getPersistedDrawerWidth = (key: string, defaultWidth: number, min: number, max: number): number => {
  try {
    const stored = window.localStorage.getItem(key);
    if (stored === null) return defaultWidth;
    const parsed = Number(stored);
    if (!Number.isFinite(parsed)) return defaultWidth;
    return Math.min(max, Math.max(min, Math.round(parsed)));
  } catch {
    return defaultWidth;
  }
};

/**
 * Persists a drawer width to localStorage.
 */
export const persistDrawerWidth = (key: string, width: number): void => {
  try {
    window.localStorage.setItem(key, String(Math.round(width)));
  } catch {
    // localStorage not available (private mode or blocked); ignore
  }
};

/**
 * Clears all persisted drawer width keys.
 * Called during full reset (e.g., Akomi logo click).
 */
export const clearPersistedDrawerWidths = (): void => {
  try {
    window.localStorage.removeItem(LOCAL_STORAGE_KEYS.LEFT_DRAWER_WIDTH);
  } catch {
    // localStorage not available; ignore
  }
};
